export const RECIPIENT = {
    MULTIPLE_CLASSES:{ display:'Classes', value:'MULTIPLE_CLASSES', inputLabel:'Classes', multipleDropDown: true },
    SINGLE_CLASS:{ display:'Students in Class', value:'SINGLE_CLASS', inputLabel:'Class', multipleDropDown: false }
};

export const RECIPIENT_ARR = [RECIPIENT.MULTIPLE_CLASSES, RECIPIENT.SINGLE_CLASS];